import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_INFO,
	SET_LOADING,
	SET_PROCESSING_RESULT,
	SET_ENODEB_PAIRING_LOADING,
	SET_ENODEB_PAIRING_RESULT,
	GENERATE_REGENERATION_AUDIT_REQUEST,
	GENERATE_REGENERATION_AUDIT_SUCCESS,
	GENERATE_REGENERATION_AUDIT_FAILURE
} from '../actions/ScriptsGenerationActions';

const initialState = {
	clustersInfo: [],
	isLoading: false,
	processingResult: null,
	isEnodebPairingLoading: false,
	enodebPairingResult: null,
	regenerationAudit: {
		isLoading: false,
		result: null,
		error: null
	},
	formState: {
		values: {
			deploymentDate: new Date(),
			excelInputFile: null,
			enodebPairingExcelFile: null,
			auditExcelFile: null
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const scriptsGenerationReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							formState: {
								...initialState.formState
							},
							processingResult: null,
							enodebPairingExcelFile: null,
							regenerationAudit: {
								isLoading: false,
								result: null,
								error: null
							}
						};
					}
					case GET_CLUSTERS_INFO: {
						return {
							...state,
							clustersInfo: action.clustersInfo
						};
					}
					case SET_LOADING: {
						return {
							...state,
							isLoading: action.isLoading
						};
					}
					case SET_PROCESSING_RESULT: {
						return {
							...state,
							processingResult: action.result
						};
					}
					case SET_ENODEB_PAIRING_LOADING: {
						return {
							...state,
							isEnodebPairingLoading: action.isLoading
						};
					}
					case SET_ENODEB_PAIRING_RESULT: {
						return {
							...state,
							enodebPairingResult: action.result
						};
					}
					case GENERATE_REGENERATION_AUDIT_REQUEST:
						return {
							...state,
							regenerationAudit: {
								isLoading: true,
								result: null,
								error: null
							}
						};
					case GENERATE_REGENERATION_AUDIT_SUCCESS:
						return {
							...state,
							regenerationAudit: {
								isLoading: false,
								result: action.payload,
								error: null
							}
						};
					case GENERATE_REGENERATION_AUDIT_FAILURE:
						return {
							...state,
							regenerationAudit: {
								isLoading: false,
								result: null,
								error: action.payload
							}
						};
					default: {
						return state;
					}
	}
};

export default scriptsGenerationReducer;
